import { _decorator, Component, UIOpacity } from 'cc';
import { DEV } from 'cc/env';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ShiningHint')
@requireComponent(UIOpacity)
export default class ShiningHint extends Component {
    @property
    private readonly startOpacity: number = 127;

    @property
    private readonly endOpacity: number = 255;

    @property({ tooltip: DEV && '透明度每秒變化的速度，數值越大變化越快' })
    private readonly speed: number = 127;

    private _shiningRate: number = 1;

    protected update(deltaTime: number) {
        this.node.opacity += deltaTime * this.speed * this._shiningRate;
        if (this.node.opacity >= this.endOpacity && this._shiningRate === 1) {
            this._shiningRate = -1;
            this.node.opacity = this.endOpacity;
        } else if (this.node.opacity <= this.startOpacity && this._shiningRate === -1) {
            this._shiningRate = 1;
            this.node.opacity = this.startOpacity;
        }
    }
}
